class CustomPackSelector extends HTMLElement {
  #controller = new AbortController();

  constructor() {
    super();
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.onPackSelect = this.onPackSelect.bind(this);
  }

  connectedCallback() {
    const { signal } = this.#controller;

    document.addEventListener("click", this.toggleDropdown, { signal });

    this.packItems.forEach(pack => {
      pack.addEventListener("click", this.onPackSelect, { signal });
    })
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get packSelector() {
    return this.querySelector('[data-pack-selector]');
  }

  get selectedPack() {
    return this.querySelector('[data-selected-pack]');
  }

  get packItems() {
    return this.querySelectorAll("[data-pack-item]");
  }

  get quantityInput() {
    return document.querySelector(".qty-selector-wrapper .qty-selector input[name='quantity']");
  }

  toggleDropdown(e) {
    if(e.target.closest("[data-selected-pack]")) {
      this.toggle();
    } else if(!e.target.closest("[data-pack-selector]")) {
      this.close();
    }
  }

  onPackSelect(e) {
    const pack = e.target.closest("[data-pack-item]");
    if(!pack) return;

    const titleEl = this.selectedPack?.querySelector(".title");
    const priceEl = this.selectedPack?.querySelector(".price");

    if (titleEl) titleEl.innerText = pack.dataset.title;
    if (priceEl) priceEl.innerText = pack.dataset.price;

    this.quantityInput.value = Number(pack.dataset.quantity) || 1;
    this.quantityInput.dispatchEvent(new Event("change", { bubbles: true }));

    this.close();
  }

  open() { 
    this.packSelector.classList.add("active"); 
  }

  close() { 
    this.packSelector.classList.remove("active"); 
  }

  toggle() { 
    this.packSelector.classList.toggle("active"); 
  }
}

if(!customElements.get("custom-pack-selector")) {
  customElements.define("custom-pack-selector", CustomPackSelector);
}